export type ResolveType = (value: (PromiseLike<unknown> | unknown)) => void;
export type RejectType = () => void;

export const backoffPause = async (retries: number, rate = 1.3): Promise<void> => {
    await new Promise(resolve => setTimeout(resolve, Math.floor(Math.pow(rate, retries) * 1000)));
};
